import {
  displayTypes,
  spaceSizeTokenMap,
  spaceSizes,
  spacingProperties
} from "./chunk.5JHTBFE5.js";
import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  o,
  r
} from "./chunk.4JTBA2KG.js";

// src/components/box/box.styles.ts
var spaceStyleKeyMap = {
  p: "padding: var(--sl-spacing-{{SIZE}});",
  pt: "padding-top: var(--sl-spacing-{{SIZE}});",
  pr: "padding-right: var(--sl-spacing-{{SIZE}});",
  pb: "padding-bottom: var(--sl-spacing-{{SIZE}});",
  pl: "padding-left: var(--sl-spacing-{{SIZE}});",
  ph: "padding-right: var(--sl-spacing-{{SIZE}}); padding-left: var(--sl-spacing-{{SIZE}});",
  pv: "padding-top: var(--sl-spacing-{{SIZE}}); padding-bottom: var(--sl-spacing-{{SIZE}});",
  m: "margin: var(--sl-spacing-{{SIZE}});",
  mt: "margin-top: var(--sl-spacing-{{SIZE}});",
  mr: "margin-right: var(--sl-spacing-{{SIZE}});",
  mb: "margin-bottom: var(--sl-spacing-{{SIZE}});",
  ml: "margin-left: var(--sl-spacing-{{SIZE}});",
  mh: "margin-right: var(--sl-spacing-{{SIZE}}); margin-left: var(--sl-spacing-{{SIZE}});",
  mv: "margin-top: var(--sl-spacing-{{SIZE}}); margin-bottom: var(--sl-spacing-{{SIZE}});"
};
var spaceInvertStyleKeyMap = {
  p: "padding: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  pt: "padding-top: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  pr: "padding-right: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  pb: "padding-bottom: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  pl: "padding-left: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  ph: "padding-right: calc(var(--sl-spacing-{{SIZE}}) * -1); padding-left: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  pv: "padding-top: calc(var(--sl-spacing-{{SIZE}}) * -1); padding-bottom: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  m: "margin: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  mt: "margin-top: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  mr: "margin-right: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  mb: "margin-bottom: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  ml: "margin-left: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  mh: "margin-right: calc(var(--sl-spacing-{{SIZE}}) * -1); margin-left: calc(var(--sl-spacing-{{SIZE}}) * -1);",
  mv: "margin-top: calc(var(--sl-spacing-{{SIZE}}) * -1); margin-bottom: calc(var(--sl-spacing-{{SIZE}}) * -1);"
};
function gen(breakpoint = "") {
  const styles = spacingProperties.reduce((result, key) => {
    result += spaceSizes.reduce((subResult, size) => {
      const token = spaceSizeTokenMap[size];
      return ` ${subResult} .box--${key}-${size}${breakpoint} { ${spaceStyleKeyMap[key].replace(/{{SIZE}}/g, token)}} .box--${key}-${size}${breakpoint}.box--invert { ${spaceInvertStyleKeyMap[key].replace(/{{SIZE}}/g, token)}} `;
    }, "");
    return result;
  }, "");
  return o(styles);
}
function generateDisplayStyles() {
  return o(displayTypes.reduce((acc, displayType) => {
    return ` ${acc} .box--display-${displayType} { display: ${displayType}; } @media (max-width: 575px) { .box-display-${displayType}-xs { display: ${displayType}; } } @media (min-width: 576px) { .box--display-${displayType}-sm { display: ${displayType}; } } @media (min-width: 768px) { .box--display-${displayType}-md { display: ${displayType}; } } @media (min-width: 992px) { .box--display-${displayType}-lg { display: ${displayType}; } } @media (min-width: 1200px) { .box--display-${displayType}-xl { display: ${displayType}; } } @media (min-width: 1400px) { .box--display-${displayType}-xxl { display: ${displayType}; } } `;
  }, ""));
}
var box_styles_default = r` ${component_styles_default} :host { display: contents; } ${generateDisplayStyles()} ${gen()} @media (max-width: 575px) { ${gen("-xs")} } @media (min-width: 576px) { ${gen("-sm")} } @media (min-width: 768px) { ${gen("-md")} } @media (min-width: 992px) { ${gen("-lg")} } @media (min-width: 1200px) { ${gen("-xl")} } @media (min-width: 1400px) { ${gen("-xxl")} } `;

export {
  box_styles_default
};
